export default __webpack_public_path__ + "static/media/cert-student-consumer.38742f7d.jpg";